<template>
  <div v-html="value.content" :data-source="value.source"></div>
</template>

<script>
export default {
  props: {
    value: Object,
  },
}
</script>
